export default "__VITE_ASSET__ZR8sxNsA__"